import type { AnyRoute } from "@tanstack/react-router";

import { createAdminsRoutes } from "./createAdminsRoutes";
import { createBranchesRoutes } from "./createBranchesRoutes";
import { createCompaniesRoutes } from "./createCompaniesRoutes";
import { createCompanyDetailRoutes } from "./createCompanyDetailRoutes";
import { createDepartmentsRoutes } from "./createDepartmentsRoutes";
import { createOrganizationStubRoutes } from "./createOrganizationStubRoutes";
import { createRegionsRoutes } from "./createRegionsRoutes";
import type { OrganizationRouteDeps } from "./organizationRouteContext";

export type {
  OrganizationRouteDeps,
  OrganizationRouteFactory,
} from "./organizationRouteContext";

// Each area's own factory allows separate workstreams to extend independently
export function createOrganizationRoutes(
  deps: OrganizationRouteDeps,
): AnyRoute[] {
  return [
    ...createCompaniesRoutes(deps),
    ...createCompanyDetailRoutes(deps),
    ...createAdminsRoutes(deps),
    ...createRegionsRoutes(deps),
    ...createBranchesRoutes(deps),
    ...createDepartmentsRoutes(deps),
    ...createOrganizationStubRoutes(deps),
  ];
}
